export const FILTER_MEDS = 'context.FILTER_MEDS';
export const RESET_FILTERS = 'context.RESET_FILTERS';
export const SET_SORT = 'context.SET_SORT';
export const UPDATE_MED = 'context.UPDATE_MED';
export const UPDATE_MEDS = 'context.UPDATE_MEDS';
export const ONLY_NEED_APPROVAL = 'context.ONLY_NEED_APPROVAL';
export const SET_ERROR_MODAL = 'context.SET_ERROR_MODAL';
export const SET_MOBILE_EDITABLE = 'context.SET_MOBILE_EDITABLE';
export const SET_DIMENSIONS = 'context.SET_DIMENSIONS';
